import { FieldType, FieldTypeType } from "../../../services/helpers/types";
import NumberField from "../../atoms/NumberField/NumberField";
import NumberNumberField from "../../atoms/NumberNumberField/NumberNumberField";
import TextField from "../../atoms/TextField/TextField";
import ToggleField from "../../atoms/ToggleField/ToggleField";
import ButtonGroupField from "../ButtonGroupField/ButtonGroupField";
import CascaderField from "../../organisms/CascaderField/CascaderField";
import MultiSelect from "../MultiSelect/MultiSelect";
import SelectField from "../SelectField/SelectField";
import StaticTextField from "../../atoms/StaticTextField/StaticTextField";
import BooleanTextField from "../BooleanTextField/BooleanTextField";
import ButtonField from "../../atoms/ButtonField/ButtonField";
import UrineField from "../UrineField/UrineField";
import BMICalculatorField from "../BMICalculatorField/BMICalculatorField";
import MoreInfoField from "../../atoms/MoreInfoField/MoreInfoField";

export const fieldRenderer = (
  field: FieldType,
  onFieldChange: (value?: string) => void,
  value?: string,
) => {
  switch (field.type) {
    case FieldTypeType.Number: {
      return (
        <NumberField field={field} value={value} onChange={onFieldChange} />
      );
    }
    case FieldTypeType.NumberNumber:
      return (
        <NumberNumberField
          field={field}
          value={value}
          onChange={onFieldChange}
        />
      );
    case FieldTypeType.Select: {
      return (
        <SelectField field={field} value={value} onChange={onFieldChange} />
      );
    }
    case FieldTypeType.ButtonGroup:
      return (
        <ButtonGroupField
          field={field}
          value={value}
          onChange={onFieldChange}
        />
      );
    case FieldTypeType.Boolean:
      return <ToggleField value={value} onChange={onFieldChange} />;
    case FieldTypeType.Text:
      return <TextField field={field} value={value} onChange={onFieldChange} />;
    case FieldTypeType.MultipleChoice:
      return (
        <MultiSelect field={field} value={value} onChange={onFieldChange} />
      );
    case FieldTypeType.Cascader:
      return (
        <CascaderField field={field} value={value} onChange={onFieldChange} />
      );
    case FieldTypeType.StaticText:
      return <StaticTextField value={value} />;
    case FieldTypeType.ButtonText:
    case FieldTypeType.BooleanText:
      return (
        <BooleanTextField
          field={field}
          value={value}
          onChange={onFieldChange}
        />
      );
    case FieldTypeType.Button:
      return (
        <ButtonField field={field} value={value} onChange={onFieldChange} />
      );

    case FieldTypeType.Urine:
      return (
        <UrineField field={field} value={value} onChange={onFieldChange} />
      );
    case FieldTypeType.BMICalculator:
      return (
        <BMICalculatorField
          field={field}
          value={value}
          onChange={onFieldChange}
        />
      );
    case FieldTypeType.TextArea: {
      return (
        <MoreInfoField field={field} value={value} onChange={onFieldChange} />
      );
    }
  }
};
